















import { AuthHttp } from "@/mixins/http/auth";
// eslint-disable-next-line no-unused-vars
import { FreeTrialConfig, Verification } from "@/types/auth";
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class VerifyEmail extends Mixins(AuthHttp) {
	verification: Verification = {};
	showErrorMessage: boolean = false;
	errorMessage: string = "";
	verifiedSuccessfully: boolean = false;

	verifying: boolean = false;

	mounted() {
		if (!this.$route.query.code) {
			this.errorMessage = "No token to verify";
			this.showErrorMessage = true;
		} else {
			this.verification = {
				token: this.$route.query.code.toString(),
			};

			this.verifying = true;
			this.verifyEmail(this.verification)
				.then(() => {
					this.verifiedSuccessfully = true;
				})
				.catch((error: any) => {
					this.errorMessage = error;
					this.showErrorMessage = true;
				})
				.finally(() => (this.verifying = false));
		}
	}
}
